// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-F":"F_sp-175w-F__HU_Qn"};